import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildSeo, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/services/")({
  head: () => {
    const seo = buildSeo({
      title: "Interior & 3D Design Services | BAZZAR 3D",
      description:
        "BAZZAR 3D — interior and commercial space design transformed into exceptional experiences. Realistic 3D designs, execution plans, and on-site supervision across Saudi Arabia.",
      keywords:
        "interior design, 3D design, decor, space design, villas, restaurants, offices, Saudi Arabia, Riyadh",
      path: "/services",
    });
    return {
      meta: seo.meta,
      links: seo.links,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbJsonLd([
              { name: "Home", path: "/" },
              { name: "Services", path: "/services" },
            ]),
          ),
        },
      ],
    };
  },
  component: lazyRouteComponent(() => import("@/pages-lazy/services-index")),
});